import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import { withRouter} from "react-router";
import {withSnackbar} from "notistack";
import {connect} from "trim-redux";
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
import {Translate} from "../../../../config/Translate";
import withWidth from "@material-ui/core/withWidth/withWidth";
import Alert from "@material-ui/lab/Alert/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle/AlertTitle";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Switch from "@material-ui/core/Switch/Switch";
import PricingHelpButton from "./components/PricingHelpButton";
import MakeSinglePricing from "./MakeSinglePricing";
import AttributeChooser from "./components/AttributeChooser";

class ProductPricing extends React.Component {
    classes = this.props.classes;
    state={
        pricing:!!this.props.pricing ? this.props.pricing : [],
        product_id: this.props.product_id,
        loading:false,
    };
    async componentDidMount(){
        await this.setState({
            pricing:!!this.props.pricing ? this.props.pricing : [],
            product_id:this.props.product_id,
        });

    }
    handleValues(values){
        this.setState({
            values
        })
    }
    render() {
        const {loading,product_id} = this.state;
        return (
            <>
                {
                    loading ? <AppCardLoaderFields/> :
                        <Grid container spacing={2} alignItems="center" justify="center">
                            <Grid item xs={12}>
                                <MakeSinglePricing
                                    product_id={product_id}
                                    value={0}
                                    reload={() => this.props.reload()}
                                />
                            </Grid>
                        </Grid>
                }

            </>
        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withWidth()(withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(ProductPricing)))));